import React from "react";

const Footer = () => {
  return (
    <footer className="app-footer">
      <span className="d-inline-block">
        Copyright FranchiseCare &copy; 2022
      </span>
    </footer>
  );
};
export default Footer;
